import nft1 from "assets/img/nfts/NftBanner1.png";
import { Link } from "react-router-dom";

const Banner1 = () => {
  return (
    <div
      className="flex w-full flex-col rounded-[20px] bg-cover px-4 py-6 sm:px-6 md:px-8 lg:px-[64px] lg:py-[56px] mb-2"
      style={{ backgroundImage: `url(${nft1})` }}
    >
      <div className="w-full">
        <h4 className="mb-3 sm:mb-[14px] max-w-full text-lg sm:text-xl font-bold text-white md:w-[64%] md:text-2xl lg:text-3xl lg:leading-[42px] xl:w-[85%] 2xl:w-[75%] 3xl:w-[52%]">
          Управляй SEO в одном месте
        </h4>
        <p className="mb-6 sm:mb-[40px] max-w-full text-sm sm:text-base font-medium text-[#E3DAFF] md:w-[64%] lg:w-[40%] xl:w-[72%] 2xl:w-[60%] 3xl:w-[45%]">
          Управления SEO-проектами LIUKIT
        </p>

        <div className="mt-6 sm:mt-[36px] flex flex-col sm:flex-row items-start sm:items-center justify-start gap-3 sm:gap-4">
          <Link to="/seo/sites" className="w-full sm:w-auto text-black linear rounded-xl bg-white px-4 py-2 text-center text-sm sm:text-base font-medium transition duration-200 hover:!bg-white/80 active:!bg-white/70">
            Сайты
          </Link>
          <Link to="/seo/links" className="w-full sm:w-auto text-black linear rounded-xl bg-white px-4 py-2 text-center text-sm sm:text-base font-medium transition duration-200 hover:!bg-white/80 active:!bg-white/70">
            Ссылки
          </Link>
          <Link to="/seo/tasks" className="w-full sm:w-auto text-black linear rounded-xl bg-white px-4 py-2 text-center text-sm sm:text-base font-medium transition duration-200 hover:!bg-white/80 active:!bg-white/70">
            Задачи
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner1;
